import React from 'react';
import { Route, Switch } from 'react-router-dom';

// const Dashboard = React.lazy(() => import('features/statistic/view/mobile/Dashboard'));
import Dashboard from 'features/statistic/view/mobile/Dashboard';

export const StatisticModule =
  <Route key="/statistic" path="/statistic">
    <Switch>
      <Route
        key="/statistic/dashboard"
        path="/statistic/dashboard"
        component={Dashboard}
      />
    </Switch>
  </Route>
